/**
 * properties have same name as that of `SidebarNavTypes` enum values
 */

import { ENHANCED_VIEW_ROUTES } from '@modules/showroom/productCollection/enhancedView/constants/cnf-product-constants'

export const SIDEBAR_CONFIG = {
  clientSelection: {
    url: '/showroom/clients',
    label: 'Client Selection',
    parentLabel: null
  },
  buyingSessionGroup: {
    url: '/showroom/clients/buyingSessionGroup',
    label: 'Buying Session Group',
    parentLabel: null
  },
  presentation: {
    url: '/showroom/clients/buyingSessionGroup/presentation',
    label: 'Presentation',
    parentLabel: 'Showroom'
  },
  lookbook: {
    url: '/showroom/clients/buyingSessionGroup/lookbook',
    label: 'Lookbook',
    parentLabel: 'Showroom'
  },
  clientCollection: {
    url: '/showroom/clients/buyingSessionGroup/activities/client-collection',
    label: 'Collection',
    parentLabel: 'Collection'
  },
  clientWishlist: {
    url: '/showroom/clients/buyingSessionGroup/activities/client-wishlist',
    label: 'Wishlist',
    parentLabel: 'Wishlist'
  },
  basketAndOrders: {
    url: '/showroom/clients/buyingSessionGroup/basketAndOrders',
    label: 'My Orders',
    parentLabel: 'My Orders'
  },
  buyingSessionActivities: {
    url: '/showroom/clients/buyingSessionGroup/activities',
    label: 'My Orders',
    parentLabel: 'My Orders'
  },
  collection: {
    url: '/showroom/clients/buyingSessionGroup/activities/collection',
    label: 'My Orders',
    parentLabel: 'My Orders'
  },
  order: {
    url: '/showroom/clients/buyingSessionGroup/activities/order',
    label: 'My Orders',
    parentLabel: 'My Orders'
  },
  buyingBoard: {
    url: '/wholesale',
    label: 'Buying Board',
    parentLabel: null
  },
  saShowroom: {
    url: '/showroom',
    label: 'Showroom',
    parentLabel: null
  },
  enhancedLookbook: {
    url: `/showroom/clients/buyingSessionGroup/${ENHANCED_VIEW_ROUTES.lookbook}`,
    label: 'Lookbook',
    parentLabel: 'Showroom'
  },
  enhancedClientCollection: {
    url: `/showroom/clients/buyingSessionGroup/activities/${ENHANCED_VIEW_ROUTES.collection}`,
    label: 'Collection',
    parentLabel: 'Collection'
  },
  enhancedClientWishlist: {
    url: `/showroom/clients/buyingSessionGroup/activities/${ENHANCED_VIEW_ROUTES.wishlist}`,
    label: 'Wishlist',
    parentLabel: 'Wishlist'
  },
  enhancedOrderCollection: {
    url: `/showroom/clients/buyingSessionGroup/activities/${ENHANCED_VIEW_ROUTES.orderCollection}`,
    label: 'Order',
    parentLabel: 'Order'
  },
  enhancedBasketAndOrders: {
    url: `/showroom/clients/buyingSessionGroup/${ENHANCED_VIEW_ROUTES.basketAndOrders}`,
    label: 'My Orders',
    parentLabel: 'My Orders'
  }
}

export const SIDEBAR_ENHANCEMENT = true
